import {CoachDetails, RegionItem} from '@/models';
import {checkImageBase64Link, checkImageLink, checkVideoLink} from './images';

type TOptions = {
  regions: RegionItem[];
}

export const handleCoachesDetailsToForm = (data: CoachDetails, {regions}: TOptions) => {
  const {
    image,
    croppedImage,
    interests,
    termsConditionsTimeStamp,
    nationalityIdImage,
    expProof,
  } = data;
  try{
    return {
      ...data,
      providedExpRegions: Array.from(
        new Set(
          regions?.filter(
            (region) =>
              region?.citiesWithIds?.some((city) =>
                data?.providedExpCities?.includes(city?.id)))
            ?.map((region) => region?.id))),
      originalImages: expProof?.filter((item) => typeof item === 'string' && checkImageLink(item)) ?? [],
      croppedImages: expProof?.filter((item) => typeof item === 'string' && checkImageLink(item)) ?? [],
      mainImageIndex: 0,
      video: expProof?.find((item) => typeof item === 'string' && checkVideoLink(item)) ?? '',
      paymentCategory: data?.paymentCategoryId,
      phone: data?.phone.replace('+966', ''),
      croppedImage: croppedImage ?? image,
      interests: interests ?? [],
      termsConditionsTimeStamp: termsConditionsTimeStamp || '',
      nationalityIdImage: nationalityIdImage ?? image,
      bankName: data?.bankInfo?.bankName,
      accountNumber: data?.bankInfo?.accountNumber,
      vatNumber: data?.bankInfo?.vatNumber,
      accountOwnerName: data?.bankInfo?.accountOwnerName,
      accountOwnerRelationship: data?.bankInfo?.accountOwnerRelationship,
    } as CoachDetails;
  }catch(e){
    console.log(e);
    return data
  }
};

export const makeCoachRequest = (payload: CoachDetails) => {
  const {image, croppedImage, phone, nationalityIdImage} = payload;
  return {
    ...payload,
    role: 'coach',
    redirect: 'coach',
    phone: `+966${phone}`,
    image: checkImageBase64Link(image) ? image : undefined,
    croppedImage: checkImageBase64Link(croppedImage) ? croppedImage : undefined,
    nationalityIdImage: checkImageBase64Link(nationalityIdImage)
      ? nationalityIdImage
      : undefined,
    bankInfo: {
      accountOwnerRelationship: payload.accountOwnerRelationship,
      accountNumber: payload.accountNumber,
      accountOwnerName: payload.accountOwnerName,
      bankName: payload.bankName,
      vatNumber: payload.vatNumber,
    },
  };
};
